import React, { useState } from "react";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { useAuth } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { t } = useLang();
  const { login, user, loading, isAdmin } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const redirectTo = location.state?.from || (isAdmin ? "/admin" : "/profile");

  if (!loading && user) return <Navigate to={redirectTo} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      toast.success(t("auth.welcome") + (u.name ? ", " + u.name : ""));
      nav(u.role === "admin" ? "/admin" : (location.state?.from || "/profile"));
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <section className="fd-container py-20 md:py-32 flex justify-center" data-testid="login-page">
        <div className="w-full max-w-md">
          <p className="fd-label mb-4">— {t("auth.login")}</p>
          <h1 className="text-3xl md:text-5xl font-light tracking-tight text-neutral-900 mb-10">{t("auth.login_title")}</h1>
          <form onSubmit={onSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <label className="fd-label block mb-2">{t("auth.email")}</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-neutral-300 focus:border-neutral-900 outline-none px-4 py-3 text-neutral-900 bg-white"
                data-testid="login-email" />
            </div>
            <div>
              <label className="fd-label block mb-2">{t("auth.password")}</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-neutral-300 focus:border-neutral-900 outline-none px-4 py-3 text-neutral-900 bg-white"
                data-testid="login-password" />
            </div>
            <button type="submit" disabled={submitting} className="fd-btn-primary w-full justify-center" data-testid="login-submit">
              {submitting ? t("common.loading") : t("auth.login")}
            </button>
            <p className="text-sm text-neutral-500 text-center">
              {t("auth.no_account")} <Link to="/register" className="text-neutral-900 underline" data-testid="link-register">{t("auth.register")}</Link>
            </p>
          </form>
        </div>
      </section>
    </Layout>
  );
}
